module.exports = __webpack_public_path__ + "static/img/4.61dc75a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjiancase/4.png
// module id = v+fm
// module chunks = 2